/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddSuccessionEmployeeCareerPathRequestDto } from '../models';
// @ts-ignore
import type { DeleteSuccessionEmployeeCareerPathRequestDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SuccessionEmployeeCareerPathDto } from '../models';
// @ts-ignore
import type { UpdateSuccessionEmployeeCareerPathRequestDto } from '../models';
/**
 * SuccessionCareerPathRestApi - axios parameter creator
 * @export
 */
export const SuccessionCareerPathRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a new career path for the employee
         * @param {string} employeeId 
         * @param {AddSuccessionEmployeeCareerPathRequestDto} addSuccessionEmployeeCareerPathRequestDto Add employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSuccessionEmployeeCareerPath: async (employeeId: string, addSuccessionEmployeeCareerPathRequestDto: AddSuccessionEmployeeCareerPathRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('addSuccessionEmployeeCareerPath', 'employeeId', employeeId)
            // verify required parameter 'addSuccessionEmployeeCareerPathRequestDto' is not null or undefined
            assertParamExists('addSuccessionEmployeeCareerPath', 'addSuccessionEmployeeCareerPathRequestDto', addSuccessionEmployeeCareerPathRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/career-paths`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSuccessionEmployeeCareerPathRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a career path by its ID
         * @param {number} careerPathId 
         * @param {string} employeeId 
         * @param {DeleteSuccessionEmployeeCareerPathRequestDto} deleteSuccessionEmployeeCareerPathRequestDto Delete employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuccessionEmployeeCareerPath: async (careerPathId: number, employeeId: string, deleteSuccessionEmployeeCareerPathRequestDto: DeleteSuccessionEmployeeCareerPathRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careerPathId' is not null or undefined
            assertParamExists('deleteSuccessionEmployeeCareerPath', 'careerPathId', careerPathId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteSuccessionEmployeeCareerPath', 'employeeId', employeeId)
            // verify required parameter 'deleteSuccessionEmployeeCareerPathRequestDto' is not null or undefined
            assertParamExists('deleteSuccessionEmployeeCareerPath', 'deleteSuccessionEmployeeCareerPathRequestDto', deleteSuccessionEmployeeCareerPathRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/career-paths/{careerPathId}`
                .replace(`{${"careerPathId"}}`, encodeURIComponent(String(careerPathId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSuccessionEmployeeCareerPathRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get career paths for the employee
         * @param {string} employeeId 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessionEmployeeCareerPaths: async (employeeId: string, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getSuccessionEmployeeCareerPaths', 'employeeId', employeeId)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/career-paths`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a career path by its ID
         * @param {number} careerPathId 
         * @param {string} employeeId 
         * @param {UpdateSuccessionEmployeeCareerPathRequestDto} updateSuccessionEmployeeCareerPathRequestDto Update employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessionEmployeeCareerPath: async (careerPathId: number, employeeId: string, updateSuccessionEmployeeCareerPathRequestDto: UpdateSuccessionEmployeeCareerPathRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careerPathId' is not null or undefined
            assertParamExists('updateSuccessionEmployeeCareerPath', 'careerPathId', careerPathId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateSuccessionEmployeeCareerPath', 'employeeId', employeeId)
            // verify required parameter 'updateSuccessionEmployeeCareerPathRequestDto' is not null or undefined
            assertParamExists('updateSuccessionEmployeeCareerPath', 'updateSuccessionEmployeeCareerPathRequestDto', updateSuccessionEmployeeCareerPathRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/career-paths/{careerPathId}`
                .replace(`{${"careerPathId"}}`, encodeURIComponent(String(careerPathId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSuccessionEmployeeCareerPathRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuccessionCareerPathRestApi - functional programming interface
 * @export
 */
export const SuccessionCareerPathRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuccessionCareerPathRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a new career path for the employee
         * @param {string} employeeId 
         * @param {AddSuccessionEmployeeCareerPathRequestDto} addSuccessionEmployeeCareerPathRequestDto Add employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSuccessionEmployeeCareerPath(employeeId: string, addSuccessionEmployeeCareerPathRequestDto: AddSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSuccessionEmployeeCareerPath(employeeId, addSuccessionEmployeeCareerPathRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionCareerPathRestApi.addSuccessionEmployeeCareerPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a career path by its ID
         * @param {number} careerPathId 
         * @param {string} employeeId 
         * @param {DeleteSuccessionEmployeeCareerPathRequestDto} deleteSuccessionEmployeeCareerPathRequestDto Delete employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, deleteSuccessionEmployeeCareerPathRequestDto: DeleteSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSuccessionEmployeeCareerPath(careerPathId, employeeId, deleteSuccessionEmployeeCareerPathRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionCareerPathRestApi.deleteSuccessionEmployeeCareerPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get career paths for the employee
         * @param {string} employeeId 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessionEmployeeCareerPaths(employeeId: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuccessionEmployeeCareerPathDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessionEmployeeCareerPaths(employeeId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionCareerPathRestApi.getSuccessionEmployeeCareerPaths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a career path by its ID
         * @param {number} careerPathId 
         * @param {string} employeeId 
         * @param {UpdateSuccessionEmployeeCareerPathRequestDto} updateSuccessionEmployeeCareerPathRequestDto Update employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, updateSuccessionEmployeeCareerPathRequestDto: UpdateSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuccessionEmployeeCareerPath(careerPathId, employeeId, updateSuccessionEmployeeCareerPathRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionCareerPathRestApi.updateSuccessionEmployeeCareerPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuccessionCareerPathRestApi - factory interface
 * @export
 */
export const SuccessionCareerPathRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuccessionCareerPathRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a new career path for the employee
         * @param {string} employeeId 
         * @param {AddSuccessionEmployeeCareerPathRequestDto} addSuccessionEmployeeCareerPathRequestDto Add employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSuccessionEmployeeCareerPath(employeeId: string, addSuccessionEmployeeCareerPathRequestDto: AddSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addSuccessionEmployeeCareerPath(employeeId, addSuccessionEmployeeCareerPathRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a career path by its ID
         * @param {number} careerPathId 
         * @param {string} employeeId 
         * @param {DeleteSuccessionEmployeeCareerPathRequestDto} deleteSuccessionEmployeeCareerPathRequestDto Delete employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, deleteSuccessionEmployeeCareerPathRequestDto: DeleteSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSuccessionEmployeeCareerPath(careerPathId, employeeId, deleteSuccessionEmployeeCareerPathRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get career paths for the employee
         * @param {string} employeeId 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessionEmployeeCareerPaths(employeeId: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuccessionEmployeeCareerPathDto>> {
            return localVarFp.getSuccessionEmployeeCareerPaths(employeeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a career path by its ID
         * @param {number} careerPathId 
         * @param {string} employeeId 
         * @param {UpdateSuccessionEmployeeCareerPathRequestDto} updateSuccessionEmployeeCareerPathRequestDto Update employee career path request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, updateSuccessionEmployeeCareerPathRequestDto: UpdateSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuccessionEmployeeCareerPath(careerPathId, employeeId, updateSuccessionEmployeeCareerPathRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuccessionCareerPathRestApi - interface
 * @export
 * @interface SuccessionCareerPathRestApi
 */
export interface SuccessionCareerPathRestApiInterface {
    /**
     * 
     * @summary Add a new career path for the employee
     * @param {string} employeeId 
     * @param {AddSuccessionEmployeeCareerPathRequestDto} addSuccessionEmployeeCareerPathRequestDto Add employee career path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApiInterface
     */
    addSuccessionEmployeeCareerPath(employeeId: string, addSuccessionEmployeeCareerPathRequestDto: AddSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a career path by its ID
     * @param {number} careerPathId 
     * @param {string} employeeId 
     * @param {DeleteSuccessionEmployeeCareerPathRequestDto} deleteSuccessionEmployeeCareerPathRequestDto Delete employee career path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApiInterface
     */
    deleteSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, deleteSuccessionEmployeeCareerPathRequestDto: DeleteSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get career paths for the employee
     * @param {string} employeeId 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApiInterface
     */
    getSuccessionEmployeeCareerPaths(employeeId: string, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuccessionEmployeeCareerPathDto>>;

    /**
     * 
     * @summary Update a career path by its ID
     * @param {number} careerPathId 
     * @param {string} employeeId 
     * @param {UpdateSuccessionEmployeeCareerPathRequestDto} updateSuccessionEmployeeCareerPathRequestDto Update employee career path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApiInterface
     */
    updateSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, updateSuccessionEmployeeCareerPathRequestDto: UpdateSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * SuccessionCareerPathRestApi - object-oriented interface
 * @export
 * @class SuccessionCareerPathRestApi
 * @extends {BaseAPI}
 */
export class SuccessionCareerPathRestApi extends BaseAPI implements SuccessionCareerPathRestApiInterface {
    /**
     * 
     * @summary Add a new career path for the employee
     * @param {string} employeeId 
     * @param {AddSuccessionEmployeeCareerPathRequestDto} addSuccessionEmployeeCareerPathRequestDto Add employee career path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApi
     */
    public addSuccessionEmployeeCareerPath(employeeId: string, addSuccessionEmployeeCareerPathRequestDto: AddSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessionCareerPathRestApiFp(this.configuration).addSuccessionEmployeeCareerPath(employeeId, addSuccessionEmployeeCareerPathRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a career path by its ID
     * @param {number} careerPathId 
     * @param {string} employeeId 
     * @param {DeleteSuccessionEmployeeCareerPathRequestDto} deleteSuccessionEmployeeCareerPathRequestDto Delete employee career path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApi
     */
    public deleteSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, deleteSuccessionEmployeeCareerPathRequestDto: DeleteSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessionCareerPathRestApiFp(this.configuration).deleteSuccessionEmployeeCareerPath(careerPathId, employeeId, deleteSuccessionEmployeeCareerPathRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get career paths for the employee
     * @param {string} employeeId 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApi
     */
    public getSuccessionEmployeeCareerPaths(employeeId: string, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionCareerPathRestApiFp(this.configuration).getSuccessionEmployeeCareerPaths(employeeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a career path by its ID
     * @param {number} careerPathId 
     * @param {string} employeeId 
     * @param {UpdateSuccessionEmployeeCareerPathRequestDto} updateSuccessionEmployeeCareerPathRequestDto Update employee career path request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionCareerPathRestApi
     */
    public updateSuccessionEmployeeCareerPath(careerPathId: number, employeeId: string, updateSuccessionEmployeeCareerPathRequestDto: UpdateSuccessionEmployeeCareerPathRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessionCareerPathRestApiFp(this.configuration).updateSuccessionEmployeeCareerPath(careerPathId, employeeId, updateSuccessionEmployeeCareerPathRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

